import { createSelector } from '@reduxjs/toolkit';

import { CommonRootState } from '../root.reducer';

const selectSelf = (state: CommonRootState) => state.userInfoLoad;

export const hasSucceededLoadingUserInfo = createSelector(selectSelf, state => state.userInfoLoadSuccess === true);
